import {useLazyQuery, gql} from '@apollo/client'

const viewerNotification = gql`
  query expiringUsersNotification {
    expiringUsersList {
      UsersDetails {
        END_DATE
        USER_EMAIL
      }
    }
  }
`

function useGetViewerNotification() {
  const [fetchViewerNotification, {data, loading, error}] = useLazyQuery(viewerNotification, {
    context: {clientName: 'adminPanel'},
    notifyOnNetworkStatusChange: true
  })
  return [fetchViewerNotification, {data, loading, error}]
}

export default useGetViewerNotification
